import React from "react";
import classNames from "classnames/bind";
import styles from "./Skeleton.module.css";

const cx = classNames.bind(styles);

export default function Skeleton({
  width,
  height,
  radius,
  style,
  className,
}) {
  return (
    <span
      className={cx("skeleton", "wrapper", className)}
      style={{
        width,
        height,
        borderRadius: radius,
        ...style,
      }}
      aria-hidden="true"
    />
  );
}

